import CustomisableWidget from '@intercom/embercom-composer/components/customisable-widget';
export default CustomisableWidget;
